import React from 'react'
import { useForm } from "react-hook-form";
import { connect } from 'react-redux'
import { Form, CardBody, Row, Col, FormGroup, Label, Input } from "reactstrap";

import { FL_TERM } from "../../components/i18n/formLabels";
import { PH_TERM } from "../../components/i18n/placeHolders";
import { ButtonClean, ButtonSearch } from "../../components/buttons/buttonsActions";
import { setFilter } from '../../redux/actions/generalActions/listActions'

const GlossaryFilters = props => {
    const { filter } = props.listState

    const { register, handleSubmit, reset } = useForm({
        defaultValues: {
            term: filter?.term || ''
        }
    });

    const onSubmit = (data, _) => props.setFilter({ ...data });

    return(<Form onSubmit={ handleSubmit(onSubmit) }>
        <CardBody>
            <Row>
                <Col md="3">
                    <FormGroup>
                        <Label>{FL_TERM}</Label>
                        <Input
                            type="text"
                            name="term"
                            placeholder={PH_TERM}
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="12" className="d-flex justify-content-center">
                    <div>
                        <ButtonSearch />
                        <ButtonClean onClick={ () => reset() } />
                    </div>
                </Col>
            </Row>
        </CardBody>
    </Form>)
}

const mapStateToProps = state => ({
    listState: state.listProps,
})
const mapActionsToProps = ({
    setFilter
})

export default connect(mapStateToProps, mapActionsToProps)(GlossaryFilters)